export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-white to-cyan-50 pt-20">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse"></div>
        <div className="absolute top-40 right-10 w-72 h-72 bg-cyan-400 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-blue-300 rounded-full mix-blend-multiply filter blur-3xl animate-pulse delay-2000"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              ノズルを設置するだけで実現！<br />
              <span className="text-blue-500">UFB DUAL</span>でお家まるごと<br />
              ウルトラファインバブル
            </h1>
            <p className="text-lg md:text-xl text-gray-600 mb-8 leading-relaxed">
              ノズル1本で、暮らし全体の"水"が変わるテクノロジー。<br />
              1ccに5,000万個以上のナノバブルを発生させる商品です。<br />
              蛇口をひねるだけのお掃除、水に触れるだけの肌ケア。
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <a
                href="#contact"
                className="bg-blue-500 text-white px-8 py-4 rounded-full hover:bg-blue-600 transition-all shadow-lg hover:shadow-xl text-lg font-semibold whitespace-nowrap"
              >
                お問い合わせ
              </a>
              <a
                href="#about"
                className="bg-white text-blue-500 border-2 border-blue-500 px-8 py-4 rounded-full hover:bg-blue-50 transition-all text-lg font-semibold whitespace-nowrap"
              >
                製品について
              </a>
            </div>
          </div>

          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="transform rotate-3 hover:rotate-0 transition-transform duration-300">
                <img
                  src="https://ufbdual.com/wp-content/uploads/2021/01/kv02.jpg"
                  alt="ウルトラファインバブル"
                  className="w-full h-64 object-cover rounded-2xl shadow-xl"
                />
              </div>
              <div className="transform -rotate-3 hover:rotate-0 transition-transform duration-300 mt-8">
                <img
                  src="https://ufbdual.com/wp-content/uploads/2021/01/kv01.jpg"
                  alt="UFB DUAL"
                  className="w-full h-64 object-cover rounded-2xl shadow-xl"
                />
              </div>
              <div className="transform -rotate-3 hover:rotate-0 transition-transform duration-300 -mt-8">
                <img
                  src="https://ufbdual.com/wp-content/uploads/2021/01/kv03-12-16-03-723.jpg"
                  alt="ナノバブル"
                  className="w-full h-64 object-cover rounded-2xl shadow-xl"
                />
              </div>
              <div className="transform rotate-3 hover:rotate-0 transition-transform duration-300">
                <img
                  src="https://ufbdual.com/wp-content/uploads/2021/01/kv04.jpg"
                  alt="水道機器"
                  className="w-full h-64 object-cover rounded-2xl shadow-xl"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mt-20 grid md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="text-blue-500 text-3xl mb-3">
              <i className="ri-search-line"></i>
            </div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">導入事例を探す</h3>
            <select className="w-full border border-gray-300 rounded-lg px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 pr-8 cursor-pointer">
              <option value="">選択してください</option>
              <option value="住まい">住まい</option>
              <option value="歯科医院">歯科医院</option>
              <option value="美容院">美容院</option>
            </select>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="text-blue-500 text-3xl mb-3">
              <i className="ri-mail-line"></i>
            </div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">お問い合わせ</h3>
            <a
              href="#contact"
              className="block text-center bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors text-sm whitespace-nowrap"
            >
              Webからのお問い合わせ
            </a>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
            <div className="text-blue-500 text-3xl mb-3">
              <i className="ri-phone-line"></i>
            </div>
            <h3 className="text-sm font-semibold text-gray-900 mb-2">お電話でのお問い合わせ</h3>
            <a
              href="tel:080-4010-5475"
              className="block text-center text-blue-500 font-bold text-lg hover:text-blue-600 transition-colors"
            >
              <i className="ri-phone-fill mr-2"></i>080-4010-5475
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
